import { Injectable } from '@angular/core';

@Injectable()
export class ValidationService {
    customRules: ICustomRules = {
        merge: function(rule1, rule2) {
            return Object.assign(rule1, rule2);
        },
        text: { maxlength: 100 },
        requiredText: { required: true },
        email: { email: true, maxlength: 100 },
        requiredEmail: {}
    };
    constructor() {
        this.extendCustomRules();
    }

    private extendCustomRules() {
        var required = { required: true };
        this.customRules.requiredText = Object.assign(
            this.customRules.text,
            required
        );
        this.customRules.requiredEmail = Object.assign(
            this.customRules.email,
            required
        );
    }

    validateWithValidator(event, options) {
        const form = $(event.target).closest('form');
        const validator = form.validate(options);
        const isValid = form.valid() ? true : false;
        const result = { isValid: isValid, validator: validator };
        if (!result.isValid) {
            event.preventDefault();
        }
        return result;
    }

    validate(event, options) {
        const result = this.validateWithValidator(event, options);
        return result.isValid;
    }
}

export class ICustomRules {
    merge: (rule: any, rule2: any) => any;
    text: any;
    requiredText: any;
    email: any;
    requiredEmail: any;
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/_services/validation.service.ts